import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollRestoration = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use instant scrolling for better mobile compatibility
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollRestoration;